<template>
  <div>
    <div class="container-fluid container-froDesk">
      <div class="wrapper">
        <div class="content-page content-froDesk">
          <div class="content">
            <div class="row">
              <!-- 科研新闻 -->
              <div class="col-lg-8">
                <div class="card">
                  <div class="card-body">
                    <div class="dropdown float-right"></div>
                    <h3 class="header-title froDeskHeader-tit mb-3 pb-2">
                      <span class="tit">科研新闻</span>
                      <span class="ml-1">Research News</span>
                    </h3>
                    <div class="inbox-widget inbox-resNews">
                      <div class="inbox-item" v-for="item in list" :key="item.id">
                        <div class="inbox-item-img" @click="toDetailPage(item.id)">
                          <el-image :src="`${uploadUrl}/upload/download?id=${item.thumbnailImage}&openStyle=1`" fit="cover" style="width: 100%; height: 100%">
                            <div slot="error" class="image-slot el-image__error">
                              暂无图片
                            </div>
                            <div slot="placeholder" class="image-slot el-image__error">
                              加载中<span class="dot">...</span>
                            </div>
                          </el-image>
                        </div>
                        <p class="inbox-item-author text-truncate" @click="toDetailPage(item.id)">{{item.title}}</p>
                        <div class="inbox-item-text">
                          <span class="resNews-name">发布人：{{item.author}}</span>
                          <span class="resNews-time">发布时间：{{item.createTime?item.createTime.substring(0,10):''}}</span>
                        </div>
                        <div class="inbox-item-p" @click="toDetailPage(item.id)" v-html="item.digest"></div>
                      </div>
                    </div>
                    <el-pagination :hide-on-single-page="true" :page-size="query.pageSize" layout="prev, pager, next" :total="total" @current-change="handlePageChange">
                    </el-pagination>
                  </div> <!-- end card-body-->
                </div> <!-- end card-->
              </div>
              <!-- end 科研新闻-->
              <!-- 政策文件 -->
              <div class="col-lg-4">
                <div class="card">
                  <div class="card-body">
                    <div class="dropdown float-right"></div>
                    <h3 class="header-title froDeskHeader-tit mb-3 pb-2">
                      <span class="tit">政策文件</span>
                      <span class="ml-1">Policy Documents</span>
                    </h3>
                    <ul class="froDesk-Lists Lists-auto">
                      <li class="h-auto" v-for="item in policyList" :key="item.id">
                        <i class="mdi mdi-arrow-right"></i>
                        <a @click="toDetailPage(item.id)">{{item.title}}</a>
                        <div class="inbox-item-text">
                          <span class="resNews-name">发布人：{{item.author}}</span>
                          <span class="resNews-time">发布时间：{{item.createTime?item.createTime.substring(0,10):''}}</span>
                        </div>
                      </li>
                    </ul>
                    <nav class="mt-2" v-if="pageNumAll>1">
                      <ul class="pagination pagination-sm justify-content-end mb-0">
                        <li class="page-item" @click="handlePage('prev')">
                          <a class="page-link" aria-label="Previous">
                            <span aria-hidden="true">«</span>
                          </a>
                        </li>
                        <li class="page-item" @click="handlePage('next')">
                          <a class="page-link" aria-label="Next">
                            <span aria-hidden="true">»</span>
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div> <!-- end card-body-->
                </div> <!-- end card-->
              </div>
              <!-- end 政策文件-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { getColumnList } from "@/api/before/home";
export default {
  name: "researchDynamics",
  data() {
    return {
      query: {
        id: 10,
        pageNumber: 1,
        pageSize: 15,
        pageSorts: [{ asc: true, column: "" }],
      },
      queryPolicy: {
        id: 16,
        pageNumber: 1,
        pageSize: 15,
        pageSorts: [{ asc: true, column: "" }],
      },
      list: [],
      total: 0,
      policyList: [],
      policyTotal: 0,
      pageNumAll: 0, //总页数
    };
  },
  mounted() {
    this.getData(10);
    this.getData(16);
  },
  methods: {
    getData(id) {
      let query = {};
      id == 10 ? (query = this.query) : (query = this.queryPolicy);
      getColumnList(query).then((res) => {
        if (res.code == 200) {
          if (id == 10) {
            this.list = res.data.records;
            this.total = res.data.total;
          } else {
            this.policyList = res.data.records;
            this.policyTotal = res.data.total;
            this.pageNumAll = Math.ceil(
              this.policyTotal / this.queryPolicy.pageSize
            );
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //去文章详情
    toDetailPage(id) {
      this.$router.push("/publicDetails/" + id);
    },
    // 分页器
    handlePageChange(val) {
      this.query.pageNumber = val;
      this.getData(10);
    },
    handlePage(name) {
      if (name == "prev") {
        if (this.queryPolicy.pageNumber - 1 < 1) return;
        this.queryPolicy.pageNumber--;
      } else {
        if (this.queryPolicy.pageNumber + 1 > this.pageNumAll) return;
        this.queryPolicy.pageNumber++;
      }
      this.getData(16);
    },
  },
};
</script>

<style>
/* 分页器样式 */
.el-pagination {
  text-align: right;
}
.el-pager li {
  margin: 0 4px;
  padding: 0;
  font-size: 13px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  box-sizing: border-box;
}
.el-pager li.active {
  color: #fff;
  background-color: #727cf5;
  border-color: #727cf5;
  border-radius: 50%;
}
.el-pager li.active:hover {
  color: #fff;
  background-color: #727cf5;
  border-color: #727cf5;
}
.el-pager li:hover {
  color: #313a46;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
  border-radius: 50%;
}
.inbox-resNews .inbox-item .inbox-item-img img {
  width: 100%;
}
</style>
<style lang="scss" scoped>
/* 科研新闻 */
.inbox-resNews .inbox-item {
  margin-bottom: 40px;
  padding: 0;
  display: block;
}
.inbox-resNews .inbox-item .inbox-item-img {
  margin-right: 30px;
  width: 200px;
  height: 150px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.inbox-resNews .inbox-item .inbox-item-author {
  margin-bottom: 10px;
  padding-bottom: 10px;
  font-size: 18px;
  border-bottom: 1px solid #e3eaef;
  cursor: pointer;
}
.inbox-resNews .inbox-item .inbox-item-text {
  text-align: right;
}
.inbox-resNews .inbox-item .inbox-item-text span {
  margin-left: 20px;
}
.inbox-resNews .inbox-item .inbox-item-p {
  position: absolute;
  left: 220px;
  bottom: 0;
  text-indent: 2em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  cursor: pointer;
}
.inbox-item:hover .inbox-item-p {
  color: #727cf5;
}
@media (max-width: 576px) {
  .inbox-resNews .inbox-item {
    margin-bottom: 20px;
  }
  .inbox-resNews .inbox-item .inbox-item-img {
    display: none;
  }
  .inbox-resNews .inbox-item .inbox-item-author {
    padding-top: 20px;
    border-top: 1px solid #e3eaef;
    border-bottom: 0;
  }
  .inbox-resNews .inbox-item:first-child .inbox-item-author {
    padding-top: 0;
    border-top: 0;
  }
  .inbox-resNews .inbox-item .inbox-item-p {
    position: static;
    left: 0;
    margin-top: 10px;
    -webkit-line-clamp: 2;
  }
}

/* 政策文件 */
.Lists-auto li {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #e3eaef;
}
.Lists-auto .inbox-item-text {
  text-align: right;
  line-height: 1;
  color: #adb5bd;
  font-size: 0.8125rem;
  margin: 0;
}
.Lists-auto .inbox-item-text span {
  margin-left: 20px;
}
</style>